import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { ThemeProvider, createTheme }, "@mui/material/Button": Button } } });
export default ClientProvider;
